import { Components, Theme } from "@mui/material";

export const MuiCssBaseline: Components<
  Omit<Theme, "MuiCssBaseline">
>["MuiCssBaseline"] = {
  styleOverrides: {
    body: {
      overflow: "hidden",
    },
  },
};
